import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { Accent, Container, H2 } from "./ui";
import { guarantee } from "../data/content";
export function GuaranteeSection() {
  return <section className="bg-white py-12 md:py-20" data-id="element-71" data-mp="9umkd36mq8ck">
      <Container data-id="element-72" data-mp="9t1mb3l3w79y">
        <div className="mx-auto flex max-w-[860px] flex-col items-center gap-6 rounded-2xl border-2 border-petrol bg-sage p-6 text-center sm:p-10 md:flex-row md:gap-10 md:text-left" data-id="element-73" data-mp="9wphe76791qs">
          <div className="flex h-32 w-32 shrink-0 flex-col items-center justify-center rounded-full bg-petrol text-white shadow-[0_12px_30px_rgba(22,78,85,0.25)] md:h-40 md:w-40" data-id="element-74" data-mp="jsafhu85dhv9">
            <ShieldCheckIcon className="h-8 w-8 md:h-10 md:w-10" aria-hidden="true" data-id="element-75" data-mp="sm5ml7stxidj" />
            <span className="mt-1 font-display text-4xl font-extrabold leading-none md:text-5xl" data-id="element-76" data-mp="xivzjm9c7xuq">{guarantee.days}</span>
            <span className="text-[11px] font-semibold uppercase tracking-[0.16em]" data-id="element-77" data-mp="12klcj7g4ellg">Day guarantee</span>
          </div>
          <div data-id="element-78" data-mp="17g0plx6b0dgt">
            <H2 data-id="element-79" data-mp="25rxbetx71625">
              {guarantee.days}-day <Accent data-id="element-80" data-mp="25syk4rqqlggp">money-back guarantee</Accent>
            </H2>
            <p className="mt-4 text-base text-ink sm:text-lg" data-id="element-81" data-mp="20t3vkuufp2yt">{guarantee.text}</p>
          </div>
        </div>
      </Container>
    </section>;
}